const parseIntegerOrDefault = (
  rawValue: string | undefined,
  defaultValue: number,
): number => {
  const normalizedValue = rawValue ?? '';
  const trimmedValue = normalizedValue.trim();

  if (trimmedValue === '') {
    return defaultValue;
  }

  const parsedValue = Number(trimmedValue);

  if (!Number.isInteger(parsedValue)) {
    return defaultValue;
  }

  return parsedValue;
};

export default parseIntegerOrDefault;
